<template src="./index.html"></template>
<script>
import { query_login_status, queryBatchLog, send_sms, submit_sms } from '@/api/organization';

export default {
    props: {
        bsdlData:{
            type: Object ,
            default: {}
        },
        logId: {
            type: Number,
            default: null
        },
        verifyLogo: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        logId:function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.smsCode = "";
                    this.loading = false;
                    this.successLogo = false;
                    queryBatchLog({logId: this.logId}).then((res) => {
                        if (res.data.code === "1") {
                            this.bimg = res.data.data.bimg;
                            this.simg = res.data.data.simg;
                            this.imgx = res.data.data.imgx + "px";
                            this.imgy = res.data.data.imgy + "px";
                        }
                    })
                })
            }
        },
    },
    data() {
        return {
            isLoggedIn: "",
            smsCode: "",
            countdown: 120,
            isDragging: false,
            startX: 0,
            startY: 0,
            maxDistance: 300,
            currentDistance: 0,
            slidePercent: 0, // 滑动比例（0~100）
            defaultBg: "#e5e7eb", // 默认背景色
            loading: false,
            bimg:"",
            simg:"",
            imgx: "0px",
            imgy: "0px",
            successLogo: false,
            timer: null
        }
    },
    mounted() {
    },
    computed: {
        gradientStyle() {
            // 渐变色仅覆盖已滑动区域，未滑动部分保持默认
            return `linear-gradient(to right, #60a5fa 0%, #3b82f6 ${this.slidePercent}%, ${this.defaultBg} ${this.slidePercent}%)`;
        },
    },
    methods: {
        // 开始倒计时
        startCountdown() {
            this.countdown = 120; // 重置倒计时
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        // 重新发送验证码
        handleResend() {
            send_sms({companyId: this.bsdlData.companyId, offset: -1}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success(res.data.data.data.value.message);
                    this.successLogo = true;
                    this.startCountdown();
                } else {
                    this.$message.error("发送验证码失败，原因：" + res.data.msg);
                }
            });
        },
        onDragStart(e) {
            // 鼠标点击
            if (this.loading || this.successLogo) return;
            this.isDragging = true;
            this.startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            document.addEventListener('mousemove', this.onDragMove);
            document.addEventListener('mouseup', this.onDragEnd);
            e.preventDefault();
        },
        onDragMove(e) {
            // 鼠标移入
            if (!this.isDragging) return;
            const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            let distance = clientX - this.startX;
            /*let sliderTrack = this.$refs.sliderTrack.getBoundingClientRect();
            let sliderButton = this.$refs.sliderButton.getBoundingClientRect();*/
            distance = Math.max(0, Math.min(distance, 300)); // 300 宽度固定
            this.currentDistance = distance;

            // 计算滑动比例（横向）
            const sliderRect = this.$refs.sliderTrack.getBoundingClientRect();
            const offsetX = e.clientX - sliderRect.left;
            this.slidePercent = Math.min(100, Math.max(0, (offsetX / sliderRect.width) * 100));
            this.updateUI(distance);
            e.preventDefault();
        },
        onDragEnd(e) {
            // 鼠标松开
            if (!this.isDragging) return;
            this.isDragging = false;
            document.removeEventListener('mousemove', this.onDragMove);
            document.removeEventListener('mouseup', this.onDragEnd);
            this.verifySlider();

            e.preventDefault();
        },
        verifySlider() {
          // 提交验证码
            this.loading = true; // 等待标志，等待请求时，需暂时禁止事件触发
            send_sms({companyId: this.bsdlData.companyId, offset: this.currentDistance}).then(res => {
                if (res.data.code === 1) {
                    if ("请重新移动滑块" === res.data.data.data.value.message) {
                        this.$message.error(res.data.data.data.value.message);
                        this.simg = res.data.data.data.value.simg;
                        this.bimg = res.data.data.data.value.bimg;
                        this.imgy = res.data.data.data.value.y + "px";
                        this.imgx = res.data.data.data.value.x + "px";
                        this.successLogo = false;
                    } else {
                        this.$message.success(res.data.data.data.value.message);
                        this.successLogo = true;
                        this.startCountdown();
                    }
                } else {
                    this.$message.error("发送验证码失败，原因：" + res.data.msg);
                }
                this.loading = false;
                this.slidePercent = 0; // 重置滑动比例
                this.updateUI(0); // 重置滑动按钮与滑动图片位置
            });
        },
        updateUI(distance) {
            let sliderButton = this.$refs.sliderButton;
            let sliderText = this.$refs.sliderText;
            let sliderPiece = this.$refs.sliderPiece;
            sliderText.style.opacity = distance > 50 ? '0' : '1';
            sliderButton.style.left = (distance - 1 )+ "px";
            sliderPiece.style.left = distance + 'px';
        },
        closediag() {
            this.$emit('closediag', false);
            this.smsCode = "";
            this.loading = false;
            this.successLogo = false;
        },
        sendVerificationCode() {
            // 模拟发送验证码
            if (this.countdown > 0) return;
            this.countdown = 60;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.timer);
                }
            }, 1000);
            send_sms({companyId: this.bsdlData.companyId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("验证码已经发送到您的手机");
                } else {
                    this.$message.error("发送验证码失败，原因：" + res.data.msg);
                }
            });
        },
        submitVerification() {
            if (!this.smsCode) {
                alert('请输入验证码');
                return;
            }
            submit_sms({companyId: this.bsdlData.companyId, smsCode: this.smsCode}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("验证成功");
                    this.$emit('closediag', false);
                    this.$emit('update', true); // 触发父组件更新
                } else {
                    this.$message.error("验证失败，原因：" + res.data.msg);
                }
            })
        }
    },
    beforeDestroy() {
        // 清除定时器
        if (this.timer) {
            clearInterval(this.timer);
        }

        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
    }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
